<template>
    <div v-bind:class="{'has-module-navigation':moduleNavigation, 'navigation-opened': navOpen}">

        <header id="page-header">
            <div class="wrapper">

              <div class="burger-menu" @click="toggleNav">
                  <span>
                    <i></i>
                    <i></i>
                    <i></i>
                  </span>
              </div>

              <div class="logo-weebox">
                <img src="../assets/logo-weebox.png">
              </div>

              <div class="logo-scope">
                <img :src="$store.getters.scope.picture.url" v-if="$store.getters.scope.picture">
                <span v-else>{{ $store.getters.scope.name }}</span>
              </div>

                <div class="spacer">
                    <span class="debug-url" v-if="$aclInterfaceValidator('is_super_admin')">{{ uri }}</span>
                </div>

                <div class="shortcuts">

                    <div v-if="$store.getters.scope.website" :class="{'loaded':refreshCron}" class="cache">
                        <a href="#" title="Refresh website cache" v-on:click="refreshWebsiteCache(urlwebsite)">
                          <icon name="refresh-ccw-05"/>
                        </a>
                    </div>

                    <div v-if="$aclInterfaceValidator('weeboxcore.person.vue')">
                        <router-link to="/contacts/person">
                          <icon name="users-01"/>
                        </router-link>
                    </div>

                    <div v-if="$store.getters.user.scopes.length > 1" class="switch">
                        <router-link to="/switch-scope">
                          <icon name="layers-two-01"/>
                        </router-link>
                    </div>

                    <div class="switch toggle-dark-mode">
                      <a @click="switchMode()">
                        <icon name="contrast-01"/>
                      </a>
                    </div>


                </div>

                <div class="account" v-if="$store.getters.user.clientable">
                    <div class="picture">
                        <figure>
                            <i v-if="!$store.getters.user.clientable.picture" class="icon icon-icon_person"></i>
                            <img v-if="$store.getters.user.clientable.picture" :src="$store.getters.user.clientable.picture.url+'/fit/100x100'"/>
                        </figure>
                    </div>
                    <div class="information">
                        <span>{{ $store.getters.user.clientable.name }}</span>
                        <span>{{ $store.getters.user.clientable.email }}</span>
                    </div>
                </div>
              <div class="account" v-if="$store.getters.user.person">
                <div class="picture">
                  <figure>
                    <i v-if="!$store.getters.user.person.picture" class="icon icon-icon_person"></i>
                    <img v-if="$store.getters.user.person.picture" :src="$store.getters.user.person.picture.url+'/fit/100x100'"/>
                  </figure>
                </div>
                <div class="information">
                  <span>{{ $store.getters.user.person.name }}</span>
                  <span>{{ $store.getters.user.person.email }}</span>
                </div>
              </div>

            </div>
        </header>

      <nav id="page-navigation-v2">
        <div class="wrapper">

          <div class="logo-weebox">
            <img src="../assets/logo-weebox.png">
          </div>

          <div class="logo-weebox-minified">
            <img src="../assets/logo-weebox-minified.png">
          </div>

          <div class="container">


          <!--
          <div class="logo-weebox" v-if="$store.getters.scope">
            <router-link to="/switch-scope" class="logo-scope" v-bind:style="{background:$store.getters.scope.color}">
              <span>{{ $store.getters.scope.slug.substr(0,1) }}</span>
            </router-link>
          </div>
          -->

          <ul class="main-navigation">
            <li v-for="nav in $navigation" v-if="checkAcl(nav.name, nav.acl) && checkScope(nav.scope)">
              <router-link :to="nav.route" class="main-link" :class="{'router-link-active':$route.path.startsWith(setActiveRoute(nav.route))}">
                <figure>
                  <!--<span class="bubble" v-if="nav.notice">{{ nav.notice }}</span>-->
                  <icon :name="nav.icon"/>
                </figure>
                <span>{{ nav.name }}</span>
              </router-link>
              <div class="sub-level" v-if="nav.children && nav.children.length">
                <ul>
                  <li v-for="item in nav.children"
                      v-if="item.acl ? checkAcl(nav.name + ' - child', item.acl) : true">
                    <router-link :to="{ name: item.route }">{{ item.name }}</router-link>
                  </li>
                </ul>
              </div>
            </li>
          </ul>

          <ul>
            <li v-if="$store.state.modules.indexOf('logout')>=0">
              <a href="#" v-on:click="logout" class="main-link">
                <figure>
                  <icon name="log-out-04"/>
                </figure>
                <span>Logout</span>
              </a>
            </li>
          </ul>

          </div>
        </div>
      </nav>

      <!--
        <nav id="page-navigation">
            <div class="wrapper">

                <div class="logo-weebox" v-if="$store.getters.scope">
                    <router-link to="/switch-scope" class="logo-scope" v-bind:style="{background:$store.getters.scope.color}">
                      <span>{{ $store.getters.scope.slug.substr(0,1) }}</span>
                    </router-link>
                </div>

                <ul>
                    <li>
                        <router-link to="/dashboard">
                            <i class="icon icon-thumb"></i>
                            <span>Accueil</span>
                        </router-link>
                    </li>
                    <li v-if="$aclInterfaceValidator('weeboxcore.schedule.vue')">
                        <router-link to="/reservation">
                            <i class="icon icon-calendar"></i>
                            <span>Calendrier</span>
                        </router-link>
                    </li>
                    <li v-if="$aclInterfaceValidator('weeboxcore.invoice.vue')">
                        <router-link to="/invoicing/invoice" v-bind:class="{'router-link-active':$route.path.startsWith('/invoicing')}">
                            <i class="icon icon-receipt"></i>
                            <span>Factures</span>
                        </router-link>
                    </li>
                    <li  v-if="$aclInterfaceValidator('weeboxshop.order.vue') || $aclInterfaceValidator('weeboxshop.brand.vue') || $aclInterfaceValidator('weeboxshop.category.vue')
                    || $aclInterfaceValidator('weeboxshop.discount.vue') || $aclInterfaceValidator('weeboxshop.inventory.vue') || $aclInterfaceValidator('weeboxshop.product.vue')
                    || $aclInterfaceValidator('weeboxshop.producttype.vue') || $aclInterfaceValidator('weeboxshop.shipping.vue') || $aclInterfaceValidator('weeboxshop.voucher.vue')">
                        <router-link to="/shop/order" v-bind:class="{'router-link-active':$route.path.startsWith('/shop')}">
                            <i class="icon icon-bag"></i>
                            <span>E-commerce</span>
                        </router-link>
                    </li>
                    <li v-if="$aclInterfaceValidator('weeboxcore.person.vue') || $aclInterfaceValidator('weeboxcore.company.vue')">
                        <router-link to="/contacts/person" v-bind:class="{'router-link-active':$route.path.startsWith('/contacts')}">
                            <i class="icon icon-team"></i>
                            <span>Contacts</span>
                        </router-link>
                    </li>

                  <li v-if="$aclInterfaceValidator('weeboxcore.campaign.vue') || $aclInterfaceValidator('weeboxcore.campaign.vue')">
                    <router-link to="/campaign" v-bind:class="{'router-link-active':$route.path.startsWith('/campaign')}">
                      <i class="icon icon-newsletter"></i>
                      <span>Campagnes</span>
                    </router-link>
                  </li>

                    <li v-if="$aclInterfaceValidator('weeboxserevita.contract.vue') && $store.getters.scope.slug == 'serevita'">
                        <router-link to="/serevita">
                            <i class="icon icon-file-group"></i>
                            <span>Contrats</span>
                        </router-link>
                    </li>
                    <li v-if="$aclInterfaceValidator('weeboxcore.media.vue')">
                        <router-link to="/media">
                            <i class="icon icon-picture"></i>
                            <span>Médias</span>
                        </router-link>
                    </li>
                    <li v-if="$aclInterfaceValidator('weeboxcore.shortlink.vue')">
                        <router-link to="/shortlink">
                            <i class="icon icon-qr-code"></i>
                            <span>QR Code</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link to="/config" v-bind:class="{'router-link-active':$route.path.startsWith('/config')}">
                            <i class="icon icon-config"></i>
                            <span>Config</span>
                        </router-link>
                    </li>

                </ul>

                <ul>
                    <li v-if="$store.state.modules.indexOf('logout')>=0">
                        <a href="#" v-on:click="logout">
                            <i class="icon icon-logout"></i>
                            <span>Logout</span>
                        </a>
                    </li>
                </ul>
            </div>
        </nav>

        <nav id="page-module-navigation" v-if="moduleNavigation">
            <div class="title">
                <h1>{{ moduleName }}</h1>
            </div>
            <ul>
                <li v-for="item in moduleNavigation" v-if="item.acl ? $aclInterfaceValidator(item.acl) : true">
                    <router-link :to="{ name: item.route }">{{ item.label }}</router-link>
                </li>
            </ul>
        </nav>

        -->

        <span v-html="cssComputed"></span>
    </div>
</template>

<script>

    import MediaService from '../modules/media/MediaService.js';

    export default {
        name: 'headerVue',
        props: ['moduleNavigation','moduleName'],
        data () {
            return {
                client: this.$store.getters.scope,
                urlwebsite: '',
                refreshCron: null,
                cssComputed: null,
                uri: null,
                navOpen: true
            }
        },
        mounted: function(){
            this.urlwebsite = this.$store.getters.scope.website + '/cron';
            this.cssComputed = '';

            this.cssComputed += '<style>';
            /*
            this.cssComputed += '#page-navigation{background:'+this.$store.getters.scope.theme_primary_color+' !important;}';
            this.cssComputed += '.calendar-header div button{background:'+this.$store.getters.scope.theme_primary_color+';}';
            this.cssComputed += '.router-link-exact-active:before{background:'+this.$store.getters.scope.theme_primary_color+' !important;}';
            this.cssComputed += '.widgets .widget .widget-preloader > div div{background:'+this.$store.getters.scope.theme_primary_color+' !important;}';
            this.cssComputed += '.bt-primary{background:'+this.$store.getters.scope.theme_primary_color+' !important;border-color:'+this.$store.getters.scope.theme_primary_color+' !important;}';
            this.cssComputed += '#page-main .content-header > .wrapper .actions ul li button{border-color:'+this.$store.getters.scope.theme_primary_color+';color:'+this.$store.getters.scope.theme_primary_color+';}';
            this.cssComputed += '.search > nav > ul li a.router-link-active, .search > nav > ul li.is-active a{ background:'+this.$store.getters.scope.theme_primary_color+' !important; }'
            this.cssComputed += '.search > nav > ul li a.router-link-active:after, .search > nav > ul li.is-active a:after{ background:'+this.$store.getters.scope.theme_primary_color+' !important; }';
            this.cssComputed += '#page-main > nav > ul > li.is-active:before, .tabs-component > ul > li.is-active:before, .sub-navigation > ul > li.is-active:before, #page-main > nav > ul > li .router-link-exact-active:before, .tabs-component > ul > li .router-link-exact-active:before, .sub-navigation > ul > li .router-link-exact-active:before{ background:'+this.$store.getters.scope.theme_primary_color+' !important; }';
            */
          /*
            this.cssComputed += ':root {';
            if( this.$store.getters.scope.theme_admin_main_color )
            {
                this.cssComputed += '   --color-main: ' + this.$store.getters.scope.theme_admin_main_color + ';';
                this.cssComputed += '   --color-main-light: ' + this.shadeColor(this.$store.getters.scope.theme_admin_main_color, 30) + ';';
                this.cssComputed += '   --color-main-dark: ' +  this.shadeColor(this.$store.getters.scope.theme_admin_main_color, -30) + ';';
            }
            if( this.$store.getters.scope.theme_admin_secondary_color )
            {
                this.cssComputed += '   --color-secondary: ' + this.$store.getters.scope.theme_admin_secondary_color + ';';
                this.cssComputed += '   --color-secondary-light: ' + this.shadeColor(this.$store.getters.scope.theme_admin_secondary_color, 30) + ';';
                this.cssComputed += '   --color-secondary-dark: ' +  this.shadeColor(this.$store.getters.scope.theme_admin_secondary_color, -30) + ';';
            }
            this.cssComputed += '}';
            this.cssComputed += '</style>';
            */

            this.uri = window.apiUrl + '/' + this.$store.getters.path

            let mode = localStorage.getItem("weebox.mode");
            if( mode != null )
            {
              document.querySelector('html').classList.add(mode);
            }

            let navStatus = localStorage.getItem("weebox.navigation");
            if( navStatus == null || navStatus == "opened" )
            {
              this.navOpen = true
            }else{
              this.navOpen = false
            }

            /*
          window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', event => {
            const newColorScheme = event.matches ? "dark" : "light";
            alert(newColorScheme)
          });

          if(window.matchMedia && window.matchMedia("(prefers-color-scheme:dark)").matches) {
            alert("dark")
          } else {
            alert("light")
          }*/

        },
        methods: {
          switchMode: function(){
            document.querySelector('html').classList.toggle('dark-mode');
            if( document.querySelector('html').classList.contains('dark-mode') ){
              localStorage.setItem("weebox.mode", "dark-mode");
            }else{
              localStorage.setItem("weebox.mode", "light-mode");
            }
          },
          toggleNav: function(){
            this.navOpen = !this.navOpen;
            if( this.navOpen ){
              localStorage.setItem("weebox.navigation", "opened");
            }else{
              localStorage.setItem("weebox.navigation", "closed");
            }
          },
          checkScope: function(rights){
            let check = true;
            let self = this;
            if( rights )
            {
              rights.forEach(function(value, index){
                if(value) {
                  check = check && (self.$store.getters.scope.slug == value)
                  console.log("### checkScope", check)
                }
              })
            }
            return check;
          },
          convertToBooleanStack : function(rights) {
            let self = this;
            return rights.map(group => {
              if (group.length === 1) {
                return self.$aclInterfaceValidator(group[0]);
              } else {
                let str = []
                group.forEach(function(value, index){
                  str.push(self.$aclInterfaceValidator(value))
                })
                return `(${str.join(' && ')})`;
              }
            }).join(' || ');
          },
          checkAcl: function(name, rights){
            let check = true;
            //let self = this;
            if( rights && rights.length > 0 )
            {
              //console.log("### checkAcl", name, rights, eval(this.convertToBooleanStack(rights)), this.convertToBooleanStack(rights))
              check = eval(this.convertToBooleanStack(rights));
              /*
              console.log("### checkAcl", name, eval(this.convertToBooleanStack(rights)), this.convertToBooleanStack(rights))
              rights.forEach(function(value, index){
                if(value) {
                  check = check && self.$aclInterfaceValidator(value)
                }
              })*/
            }
            //console.log("### checkAcl", name, check)
            return check;
          },
          setActiveRoute: function(uri){
            let segments = uri.split('/');
            segments.shift()
            if( segments.length > 1 )
            {
              return '/' + segments[0];
            }
            return uri;
          },
            shadeColor: function(color, percent) {

                var R = parseInt(color.substring(1,3),16);
                var G = parseInt(color.substring(3,5),16);
                var B = parseInt(color.substring(5,7),16);

                R = parseInt(R * (100 + percent) / 100);
                G = parseInt(G * (100 + percent) / 100);
                B = parseInt(B * (100 + percent) / 100);

                R = (R<255)?R:255;
                G = (G<255)?G:255;
                B = (B<255)?B:255;

                var RR = ((R.toString(16).length==1)?"0"+R.toString(16):R.toString(16));
                var GG = ((G.toString(16).length==1)?"0"+G.toString(16):G.toString(16));
                var BB = ((B.toString(16).length==1)?"0"+B.toString(16):B.toString(16));

                return "#"+RR+GG+BB;
            },
            refreshWebsiteCache: function(url = ''){

                var self = this;
                this.refreshCron = true;

                if(confirm("Voulez-vous vraiment supprimer les caches media/web  ?")) {
                    MediaService.clearCache().then(response => {
                        axios.get(url).then(function(response){
                            self.refreshCron = false;
                        });
                    });
                }else{
                    this.refreshCron = false;
                }
            },
            logout: function(event) {
                this.$store.dispatch("logout").then(() => {
                    this.$router.push("/login")
                });
            },
            onChange: function(event){
                this.$store.dispatch("switchScope", event.srcElement.value).then(() => {
                    //this.$router.push("/dashboard")
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/layouts/Header.vue